import { detect } from 'detect-browser';

const checkUnsupportedBrowser = () => {
  const browser = detect();
  return {
    browserIsNotSupported: !browser || browser.name === 'ie',
    browserName: 'Microsoft Internet Explorer'
  };
};

export default checkUnsupportedBrowser;
